<script>
export default {
  props: ['data'],
};
</script>

<template>
  <div class="site">
    <div class="site-picture" :style="data.image && { backgroundImage: `url(${data.image})` }" />
    <span class="marker" :class="data.index !== undefined ? `marker-${data.index}` : ''"></span>

    <span class="title">{{ data.caption }}</span>
  </div>
</template>

<style scoped lang="scss">
@use '@/styles/colors.scss';

.site {
  display: flex;
  align-items: center;
  max-width: 256px;

  .site-picture {
    flex-shrink: 0;
    width: 31px;
    height: 24px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: right;
  }

  .marker {
    flex-shrink: 0;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    background-image: url('./../../../assets/Marker-home.png');

    height: 24px;
    width: 16px;
    margin-left: -8px;
  }

  @for $i from 1 through 10 {
    .marker-#{$i} {
      background-image: url('./../../../assets/Marker-#{$i}.png');
    }
  }

  .title {
    margin-left: 4px;
    font-weight: 700;
    color: #3c3c3b;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
